// extracted by mini-css-extract-plugin
export default {"root":"PageName_root__g1HVZ","icon":"PageName_icon__BFgsF","title":"PageName_title__1dEPd","addon":"PageName_addon__-G-E+"};